import template from './staff.html';
import controller from './staff.controller';

let component = {
  restrict: 'E',
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    isOnline: '<'
  },
};

export default component;

